import { useResources } from '@rhg/hooks/use-resources';
import { ReactNode } from 'react';

interface Props {
    withThemes?: boolean;
    themes?: string[];
    children: ReactNode;
}

const HasResourcesConfigured = ({
    children,
    withThemes = false,
    themes = [],
}: Props) => {
    const { resources, isFetched } = useResources({
        themes: withThemes ? themes : undefined,
    });
    const isEnabled = isFetched && resources && resources.length > 0;
    return <>{isEnabled ? children : null}</>;
};

export default HasResourcesConfigured;
